module.exports = __webpack_public_path__ + "static/media/Exact_Icon.cf543386.png";